import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from '../routes/AppRoutes.js';
import { TelegramNavigationBridge } from '../features/telegram/telegramNavigation.js';
import { TelegramProvider } from '../features/telegram/TelegramProvider.js';
import { TelegramAuthBoundary } from '../features/telegram/TelegramAuthBoundary.js';
import { AuthProvider } from '../features/auth/AuthProvider.js';

export const App: React.FC = () => {
  return (
    <TelegramProvider>
      <AuthProvider>
        <TelegramAuthBoundary>
          <BrowserRouter>
            <TelegramNavigationBridge />
            <AppRoutes />
          </BrowserRouter>
        </TelegramAuthBoundary>
      </AuthProvider>
    </TelegramProvider>
  );
};
